import { Product, Pricing } from '@/manager/product/models/product.model';
import { Budget } from '@/manager/budget/models/budget.model';


export interface BudgetLineInterface {
    id?: string;
    amount: number;
    budget?: Budget;
    prepaidPrice?: number;
    pricingApplied?: number;
    totalPricingApplied?: number;
    paymentPending?: number;
    product?: Product;
    productName?: string;
    tax?: number;
    totalPrepaidPrice?: number;
    totalPrepaidPriceTax?: number;
    totalPrepaidPriceWithoutTax?: number;
    totalPrice?: number;
    totalPriceTax?: number;
    totalPriceWithoutTax?: number;
}

export class BudgetLine implements BudgetLineInterface, Pricing {
    public id?: string;
    public amount: number;
    public budget?: Budget;
    public prepaidPrice?: number;
    public pricingApplied?: number;
    public totalPricingApplied?: number;
    public paymentPending?: number;
    public product?: Product;
    public productName?: string;
    public tax?: number;
    public totalPrepaidPrice?: number;
    public totalPrepaidPriceTax?: number;
    public totalPrepaidPriceWithoutTax?: number;
    public totalPrice?: number;
    public totalPriceTax?: number;
    public totalPriceWithoutTax?: number;

    constructor() {
        this.product = new Product();
        this.amount = 0;
        this.pricingApplied = 0;
        this.totalPrepaidPrice = 0;
        this.totalPricingApplied = 0;
        this.totalPrice = 0;
    }
}
